import { getToken, getTokenData, routesAvailableWithoutAuth } from '@/features/auth/helpers';
import { isLocalhost, redirectTo, redirectToSignInWithLogoutCheck } from '@/features/common/helpers';
import { fetchUserInfo, trackCurrentPage } from '@/features/common/services/common.services';
import { Route, RouteMeta, NavigationGuardNext } from 'vue-router';
import { trackPageTypes } from '@/features/common/constants';
import { saveTokenOnLegacySite } from '@/features/auth/services/auth.services';

export function setPageTitle(to: Route): void {
  const meta = (to.meta as RouteMeta);
  const { title } = meta;
  document.title = title;
}

export async function redirectToLoginCheck(): Promise<boolean> {
  const userInfo = await fetchUserInfo();

  if (userInfo && !userInfo.isUseNewSite && !isLocalhost()) {
    const tokenData = getTokenData();
    await saveTokenOnLegacySite(tokenData);
    redirectTo('/webship/v2logincheck.aspx');
    return true;
  }

  return false;
}

export const isAuthenticatedAndGoToSignIn = (isAuth: boolean, to: Route): boolean => {
  return isAuth && to.name === 'sign-in';
};

export const isNotAuthenticatedButVisitAuthorizedPage = (isAuth: boolean, to: Route): boolean => {
  return !isAuth
    && !routesAvailableWithoutAuth.some((route) => to.path.includes(route));
};

export const middlewareBefore = async (
  to: Route,
  __: Route,
  next: NavigationGuardNext,
): Promise<void> => {
  setPageTitle(to);

  const isAuth = !!getToken();

  if (isAuthenticatedAndGoToSignIn(isAuth, to)) {
    if (await redirectToLoginCheck()) return;

    next({ name: 'dashboard' });
    return;
  }

  if (isNotAuthenticatedButVisitAuthorizedPage(isAuth, to)) {
    if (isLocalhost()) {
      next({ name: 'sign-in', query: { redirectTo: to.path } });
    } else {
      redirectToSignInWithLogoutCheck(to.path);
    }
    return;
  }

  next();
};

export const middlewareAfter = async (
  to: Route,
): Promise<void> => {
  const isAuth = !!getToken();
  if (!isAuth) return;
  if (!to.name) return;

  const pageType = trackPageTypes[to.name];
  if (!pageType) return;

  trackCurrentPage(pageType);
};
